import clsx from 'clsx';
import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { getLobbyConfig } from '../../../../lobby/functions';
import DeviceStatus from '../../../../prejoin/components/web/preview/DeviceStatus';
import { isRoomNameEnabled } from '../../../../prejoin/functions.web';
import Toolbox from '../../../../toolbox/components/web/Toolbox';
import { isButtonEnabled } from '../../../../toolbox/functions.web';
import { getConferenceName } from '../../../conference/functions';
import { PREMEETING_BUTTONS, THIRD_PARTY_PREJOIN_BUTTONS } from '../../../config/constants';
import { codiceStanzaPerVisualizzazione } from '../../../../lobby/functions';
import Tooltip from '../../../tooltip/components/Tooltip';
import { isPreCallTestEnabled } from '../../functions';
import ConnectionStatus from './ConnectionStatus';
import Preview from './Preview';
import RecordingWarning from './RecordingWarning';
import UnsafeRoomWarning from './UnsafeRoomWarning';
import Spinner from '../../../../base/ui/components/web/Spinner';
const useStyles = makeStyles()(theme => {
    return {
        container: {
            height: '100%',
            position: 'absolute',
            inset: '0 0 0 0',
            display: 'flex',
            backgroundColor: theme.palette.preMeetingBackground,
            zIndex: 252,
            '@media (max-width: 720px)': {
                flexDirection: 'column-reverse'
            }
        },
        content: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            flexShrink: 0,
            boxSizing: 'border-box',
            padding: '24px 0 16px',
            position: 'relative',
            width: '400px',
            height: '100%',
            zIndex: 252,
            '@media (max-width: 720px)': {
                height: 'auto',
                margin: '0 auto'
            },
            // mobile phone landscape
            '@media (max-width: 420px)': {
                padding: '16px 16px 0 16px',
                width: '100%'
            },
            '@media (max-width: 400px)': {
                padding: '16px'
            }
        },
        contentControls: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'stretch',
            margin: 'auto',
            width: '100%'
        },
        paddedContent: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '0 50px',
            '& > *': {
                width: '100%',
                boxSizing: 'border-box'
            }
        },
        title: {
            ...theme.typography.heading4,
            color: theme.palette.prejoinTitleText,
            marginBottom: theme.spacing(3),
            textAlign: 'center',
            '@media (max-width: 400px)': {
                display: 'none'
            }
        },
        roomNameContainer: {
            width: '100%',
            textAlign: 'center',
            marginBottom: theme.spacing(4)
        },
        roomName: {
            ...theme.typography.heading5,
            color: theme.palette.prejoinRoomNameText,
            display: 'inline-block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            maxWidth: '100%',
        }
    };
});
const PreMeetingScreen = ({ _buttons, _isPreCallTestEnabled, _premeetingBackground, _roomName, children, className, showDeviceStatus, showRecordingWarning, showUnsafeRoomWarning, skipPrejoinButton, title, videoMuted, videoTrack }) => {
    const { classes } = useStyles();
    //const containerClassName = `premeeting-screen ${className ? className : ''}`;
    let style = _premeetingBackground ? {
        background: _premeetingBackground,
        backgroundPosition: 'center',
        backgroundSize: 'cover'
    } : {};
    let us = localStorage.getItem("user");
    let isModerator = false;
    let stile = {};
    if (us != null) {
        var user = JSON.parse(us?.toString());
        if (user !== null) {
            if (user.result == 1) {
                if (_roomName.includes(user.roomname)) {
                    isModerator = true;
                    stile = { visibility: 'hidden' };
                }
            }
        }
    }
    const roomNameRef = useRef(null);
    const [isOverflowing, setIsOverflowing] = useState(false);
    useEffect(() => {
        if (roomNameRef.current) {
            const element = roomNameRef.current;
            const elementStyles = window.getComputedStyle(element);
            const elementWidth = Math.floor(parseFloat(elementStyles.width));
            setIsOverflowing(element.scrollWidth > elementWidth + 1);
        }
    }, [_roomName]);
    return (React.createElement("div", null,
        isModerator && (React.createElement("div", { style: { position: "absolute", top: '50%', left: '50%' } },
            React.createElement(Spinner
            // @ts-ignore
            , { 
                // @ts-ignore
                isCompleting: false, size: 'large' }))),
        React.createElement("div", { className: clsx('premeeting-screen', classes.container, className), style: stile },
            React.createElement("div", { style: style },
                React.createElement("div", { className: classes.content },
                    _isPreCallTestEnabled && React.createElement(ConnectionStatus, null),
                    React.createElement("div", { className: classes.contentControls },
                        React.createElement("div", { className: classes.paddedContent },
                            React.createElement("h1", { className: classes.title }, title),
                            _roomName && (React.createElement("span", { className: classes.roomNameContainer }, isOverflowing ? (React.createElement(Tooltip, { content: codiceStanzaPerVisualizzazione(_roomName) },
                                React.createElement("span", { className: classes.roomName, ref: roomNameRef }, codiceStanzaPerVisualizzazione(_roomName)))) : (React.createElement("span", { className: classes.roomName, ref: roomNameRef }, codiceStanzaPerVisualizzazione(_roomName))))),
                            children),
                        _buttons.length && React.createElement(Toolbox, { toolbarButtons: _buttons }),
                        React.createElement("div", { className: classes.paddedContent },
                            skipPrejoinButton,
                            showUnsafeRoomWarning && React.createElement(UnsafeRoomWarning, null),
                            showDeviceStatus && React.createElement(DeviceStatus, null),
                            showRecordingWarning && React.createElement(RecordingWarning, null))))),
            React.createElement(Preview, { videoMuted: videoMuted, videoTrack: videoTrack }))));
};
/**
 * Maps (parts of) the redux state to the React {@code Component} props.
 *
 * @param {Object} state - The redux state.
 * @param {Object} ownProps - The props passed to the component.
 * @returns {Object}
 */
function mapStateToProps(state, ownProps) {
    const { hiddenPremeetingButtons, prejoinConfig } = state['features/base/config'];
    const { toolbarButtons } = state['features/toolbox'];
    const { knocking } = state['features/lobby'];
    const { showHangUp: showHangUpLobby = true } = getLobbyConfig(state);
    const { showHangUp: showHangUpPrejoin = true } = prejoinConfig || {};
    const premeetingButtons = (ownProps.thirdParty
        ? THIRD_PARTY_PREJOIN_BUTTONS
        : PREMEETING_BUTTONS).filter((b) => !(hiddenPremeetingButtons || []).includes(b));
    const shouldShowHangUp = knocking ? showHangUpLobby : showHangUpPrejoin;
    if (shouldShowHangUp && !premeetingButtons.includes('hangup')) {
        premeetingButtons.push('hangup');
    }
    const { premeetingBackground } = state['features/dynamic-branding'];
    return {
        // For keeping backwards compat.: if we pass an empty hiddenPremeetingButtons
        // array through external api, we have all prejoin buttons present on premeeting
        // screen regardless of passed values into toolbarButtons config overwrite.
        // If hiddenPremeetingButtons is missing, we hide the buttons according to
        // toolbarButtons config overwrite.
        _buttons: hiddenPremeetingButtons
            ? premeetingButtons
            : premeetingButtons.filter(b => isButtonEnabled(b, toolbarButtons)),
        _isPreCallTestEnabled: isPreCallTestEnabled(state),
        _premeetingBackground: premeetingBackground,
        _roomName: isRoomNameEnabled(state) ? getConferenceName(state) : ''
    };
}
export default connect(mapStateToProps)(PreMeetingScreen);
